import { Card, CardContent } from "../ui/card";
import { Users, BarChart, Home, Settings } from "lucide-react";

export default function LandingPage({ setActiveSection }) {
  const sections = [
    { name: "User Management", icon: Users, section: "Applicators" },
    { name: "Design Overview", icon: BarChart, section: "All Designs" },
    { name: "Pricing", icon: Home, section: "Resin Cost" },
    { name: "Quick Actions", icon: Settings, section: "Assign Role" },
  ];

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-l-[3px] tw-border-[#00B5ED] tw-h-full tw-text-center tw-flex-1 tw-p-6 tw-bg-[#f5f5f5] tw-rounded-e-md">
      {/* Hero Section */}
      <div className="tw-mb-6">
        <h1 className="tw-text-3xl tw-font-bold tw-text-[#00B5ED]">
          Welcome to the Admin Dashboard
        </h1>
        <p className="tw-text-gray-600 tw-mt-2">
          Manage users, analyze data, and configure settings with ease.
        </p>
      </div>

      {/* Quick Links */}
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-mt-6">
        {sections.map(({ name, icon: Icon, section }) => (
          <Card
            key={name}
            className="tw-bg-white tw-shadow-md tw-rounded-2xl tw-p-6 tw-flex tw-items-center tw-gap-4 tw-cursor-pointer hover:tw-shadow-lg tw-transition-all"
            onClick={() => setActiveSection(section)}
          >
            <Icon className="tw-w-10 tw-h-10 tw-self-left tw-text-[#00B5ED]" />
            <CardContent className="tw-text-center tw-py-0">
              <h3 className="tw-text-lg tw-font-semibold">{name}</h3>
              <p className="tw-text-gray-500 tw-text-sm">Go to {name}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
